import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyDl_AqdWHfiG5L89480hd0LDMlDwZF1eYs',
  authDomain: 'sundaybestapp.com',
  projectId: 'sundaybestappx',
  storageBucket: 'sundaybestappx.firebasestorage.app',
  messagingSenderId: '112333462194',
  appId: '1:112333462194:web:1e0b9e05fada29ba1dc7ab',
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
